// extracted by mini-css-extract-plugin
export default {"handleName":"stats_handleName__wrubF","sectionHeading":"stats_sectionHeading__+W5hS"};